import { Laya } from "../../../../Laya";
import { LayaGL } from "../../../layagl/LayaGL";
import { Web2DGraphicsIndexBuffer, Web2DGraphicsVertexBuffer } from "../../RenderModuleData/WebModuleData/2D/Web2DGraphic2DBuffer";
import { Web2DGraphic2DIndexDataView, Web2DGraphic2DVertexDataView } from "../../RenderModuleData/WebModuleData/2D/Web2DGraphic2DBufferDataView";
import { WebRender2DPass, WebRender2DPassManager } from "../../RenderModuleData/WebModuleData/2D/WebRender2DPass";
import { Web2DBaseRenderDataHandle, WebGraphics2DBufferBlock, WebGraphics2DVertexBlock, WebMesh2DRenderDataHandle, WebPrimitiveDataHandle, WebSpineRenderDataHandle } from "../../RenderModuleData/WebModuleData/2D/WebRenderDataHandle";
import { WebGlobalRenderData, WebRenderStruct2D } from "../../RenderModuleData/WebModuleData/2D/WebRenderStruct2D";
import { WebGLSetRenderData, WebGLSetShaderDefine } from "../RenderDevice/WebGLRenderCMD";
import { WebGLBlit2DQuadCMD, WebGLDraw2DElementCMD, WebGLSetRendertarget2DCMD } from "./WebGL2DRenderCMD";
import { WebGLPrimitiveRenderElement2D } from "./WebGLPrimitiveRenderElement2D";
import { WebglRenderContext2D } from "./WebGLRenderContext2D";
import { WebGLRenderElement2D } from "./WebGLRenderElement2D";
export class WebGLRender2DProcess {
    constructor() {
    }
    createGraphic2DBufferBlock() {
        return new WebGraphics2DBufferBlock();
    }
    createGraphic2DVertexBlock() {
        return new WebGraphics2DVertexBlock();
    }
    create2DGraphicVertexDataView(wholeBuffer, elementOffset, elementSize, stride) {
        return new Web2DGraphic2DVertexDataView(wholeBuffer, elementOffset, elementSize, stride);
    }
    create2DGraphicIndexDataView(wholeBuffer, elementSize) {
        return new Web2DGraphic2DIndexDataView(wholeBuffer, elementSize);
    }
    create2DGraphicIndexBuffer() {
        return new Web2DGraphicsIndexBuffer();
    }
    createPrimitiveRenderElement2D() {
        return new WebGLPrimitiveRenderElement2D();
    }
    create2DGraphicVertexBuffer() {
        return new Web2DGraphicsVertexBuffer();
    }
    createRender2DPassManager() {
        return new WebRender2DPassManager();
    }
    create2DGlobalRenderDataHandle() {
        return new WebGlobalRenderData();
    }
    createSpineRenderDataHandle() {
        return new WebSpineRenderDataHandle();
    }
    create2D2DPrimitiveDataHandle() {
        return new WebPrimitiveDataHandle();
    }
    create2DBaseRenderDataHandle() {
        return new Web2DBaseRenderDataHandle();
    }
    createMesh2DRenderDataHandle() {
        return new WebMesh2DRenderDataHandle();
    }
    createSetRenderDataCMD() {
        return new WebGLSetRenderData();
    }
    createSetShaderDefineCMD() {
        return new WebGLSetShaderDefine();
    }
    createBlit2DQuadCMDData() {
        return new WebGLBlit2DQuadCMD();
    }
    createDraw2DElementCMDData() {
        return new WebGLDraw2DElementCMD();
    }
    createSetRendertarget2DCMD() {
        return new WebGLSetRendertarget2DCMD();
    }
    createRenderElement2D() {
        return new WebGLRenderElement2D();
    }
    createRenderContext2D() {
        return new WebglRenderContext2D();
    }
    createRender2DPass() {
        return new WebRender2DPass();
    }
    createRenderStruct2D() {
        return new WebRenderStruct2D();
    }
}
Laya.addBeforeInitCallback(() => {
    if (!LayaGL.render2DRenderPassFactory)
        LayaGL.render2DRenderPassFactory = new WebGLRender2DProcess();
});
